import type { GameStarted, GameFinished } from "../core/types";
import { posthog } from "src/initialisePostHog";

const {
  gtag = (...args: unknown[]) => {
    console.warn(...args);
    console.warn("failed to load gtag");
  }
} = window as unknown as { gtag?: (...args: unknown[]) => void };

// PostHog $pageview/$pageleave events are captured automatically via
// capture_pageview: "history_change" (see initialisePostHog.ts), so this helper
// only forwards the pageview to Google Analytics (gtag) — capturing it in
// PostHog here too would double-count.
export function logPageView(pageTitle: string, pageUrl: string, pageAttributes: Record<string, unknown> = {}) {
  gtag("config", "G-1QEZXPWG5V", {
    page_title: pageTitle,
    page_location: pageUrl,
    ...pageAttributes
  });
}

export function logGameStarted(attributes: GameStarted) {
  gtag("event", "game_started", attributes);
  posthog.capture("game_started", attributes);
}

export function logGameWon(attributes: GameFinished) {
  gtag("event", "game_won", attributes);
  posthog.capture("game_won", attributes);
}

export function logGameLost(attributes: GameFinished) {
  gtag("event", "game_lost", attributes);
  posthog.capture("game_lost", attributes);
}
export function logTutorialBegin() {
  gtag("event", "tutorial_begin");
  posthog.capture("tutorial_begin");
}

export function logTutorialComplete() {
  gtag("event", "tutorial_complete");
  posthog.capture("tutorial_complete");
}

export function logTutorialNavigatedForward(index: number) {
  gtag("event", "tutorial_navigated_forward", {
    help_index: index
  });
  posthog.capture("tutorial_navigated_forward", {
    help_index: index
  });
}

export function logTutorialNavigatedBackward(index: number) {
  gtag("event", "tutorial_navigated_backward", {
    help_index: index
  });
  posthog.capture("tutorial_navigated_backward", {
    help_index: index
  });
}
